/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const EmploymentFragment = `
    fragment EmploymentFragment on Employment {
  _id
  type
  status
  title
  role
  hireDate
  startDate
  terminationDate
  profession
  legalSex
  stateOfResidence
  onboardingCompleteDate
}
    `
export const ProviderIdentifierFragment = `
    fragment ProviderIdentifierFragment on ProviderIdentifier {
  id
  type
  value
  createdDate
  lastModified
}
    `
export const PractMgrReferenceFragment = `
    fragment PractMgrReferenceFragment on Reference {
  id
  display
}
    `
export const ExpectedHoursFragment = `
    fragment ExpectedHoursFragment on ExpectedHours {
  weeklyMinutesTotal
  serviceCategory {
    code
  }
  startDate
  endDate
}
    `
export const PayerSummaryFrag = `
    fragment PayerSummaryFrag on Payer {
  id
  name
  stateCode
  status
}
    `
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const ActionEntryFragment = `
    fragment ActionEntryFragment on ActionEntry {
  author {
    ...AuditEntryFragment
  }
  code
  description
}
    `
export const CheckEligibilityFragment = `
    fragment CheckEligibilityFragment on EligibilityVerification {
  id
  isActive
  benefitSummaryPdfFile
  generatingBenefitSummaryPdfFile
  billingInsuranceId
  ts
  insurancePlanId
  requestId
  actionLog {
    ...ActionEntryFragment
  }
}
    `
export const FileFragment = `
    fragment FileFragment on File {
  mimeType
  name
  url
}
    `
export const ConsentPacketInfoFragment = `
    fragment ConsentPacketInfoFragment on ConsentPacketInfo {
  signedDate
  agreementId
  sent {
    ...AuditEntryFragment
  }
}
    `
export const BillingInsuredFragment = `
    fragment BillingInsuredFragment on BillingInsured {
  id
  type
  eligibilityVerified
  eligibilityReason
  relationship
  firstName
  lastName
  middleInitial
  addressComponents {
    street
    city
    state
    zipcode
  }
  dateOfBirth
  legalSex
  phone
  insurancePlanId
  outOfNetwork
  outOfNetworkPlan {
    state {
      code
      name
    }
    name
  }
  note
  idNumber
  policyGroupFecaNumber
  policyGroupName
  effectiveDate
  expirationDate
  coPay
  cardFront {
    ...FileFragment
  }
  cardBack {
    ...FileFragment
  }
  medicaidIdNumber
  medicaidCard {
    ...FileFragment
  }
  medicareIdNumber
  medicareCard {
    ...FileFragment
  }
  emrSyncStatus
  priorAuthRequired
  payerPlanName
  payerPlanType
  deductible
  familyDeductible
  coinsurance
  otherPayerInfo
  referralRequired
}
    `
export const BillingFullFragment = `
    fragment BillingFullFragment on PatientBilling {
  id
  treatmentId
  patientId
  idRelationship
  idType
  idValue
  idFile {
    ...FileFragment
  }
  fullConsentPackedSigned
  consentPacketInfo {
    ...ConsentPacketInfoFragment
  }
  creditCardOnFile
  selfPay
  hasBillableAppointment
  insurances {
    ...BillingInsuredFragment
  }
  emrSyncStatistics {
    emrSyncStatus
    lastSynced {
      ...AuditEntryFragment
    }
  }
  comments {
    authorReference {
      id
      display
    }
    time
    text
  }
}
    `
export const DocumentFragment = `
    fragment DocumentFragment on Document {
  id
  file {
    ...FileFragment
  }
  created {
    ...AuditEntryFragment
  }
  modified {
    ...AuditEntryFragment
  }
}
    `
export const PatientIntegrationFragment = `
    fragment PatientIntegrationFragment on PatientIntegration {
  emrId
  lumaId
  nextgenId
  medplumId
  mmrId
  isActive
}
    `
export const ContactFragment = `
    fragment ContactFragment on Contact {
  id
  firstName
  lastName
  relation
  phone
  email
  use
  primary
}
    `
export const PatientDemographicsFragment = `
    fragment PatientDemographicsFragment on PatientDemographics {
  patientId
  firstName
  middleName
  lastName
  username
  preferredName
  pronouns
  mrn
  gender
  genderIdentity
  genderDetails
  addressComponents {
    street
    city
    state
    zipcode
  }
  phone
  primaryPhone
  email
  primaryEmail
  status
  dateOfBirth
  timezone
  picture
  languages
  preferredLanguage
  contacts {
    ...ContactFragment
  }
  registrationSource
  videoLink
}
    `
export const CareTeamMemberFragment = `
    fragment CareTeamMemberFragment on CareTeamMember {
  id
  role
  isEnabled
  displayName
  isPctm
}
    `
export const PatientCareFragment = `
    fragment PatientCareFragment on PatientCare {
  scaleId
  device {
    type
    useMobileApp
  }
  referralSource
  hospitalized
  disableChat
  careTeam {
    ...CareTeamMemberFragment
  }
  diagnosis
  medicalDiagnosis {
    code
    name
  }
  questionnaires {
    name
    score
  }
}
    `
export const PatientFragment = `
    fragment PatientFragment on Patient {
  integration {
    ...PatientIntegrationFragment
  }
  demographics {
    ...PatientDemographicsFragment
  }
  care {
    ...PatientCareFragment
  }
}
    `
export const PatientResponseFragment = `
    fragment PatientResponseFragment on PatientResponse {
  patientId
  treatmentId
}
    `
export const SavePatientBillingDocument = `
    mutation savePatientBilling($input: UpdatePatientBillingInput!) {
  savePatientBilling(input: $input) {
    ...BillingFullFragment
  }
}
    ${BillingFullFragment}
${FileFragment}
${ConsentPacketInfoFragment}
${AuditEntryFragment}
${BillingInsuredFragment}`
export const GeneratePatientLinkDocument = `
    mutation generatePatientLink($input: GeneratePatientLinkInput!) {
  generatePatientLink(input: $input) {
    shortLink
    fullLink
  }
}
    `
export const AppendDocumentsDocument = `
    mutation appendDocuments($treatmentId: ID!, $content: [CreateDocumentInput!]!) {
  appendDocuments(treatmentId: $treatmentId, content: $content) {
    ...DocumentFragment
  }
}
    ${DocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const UpdateDocumentsDocument = `
    mutation updateDocuments($treatmentId: ID!, $content: [UpdateDocumentInput!]!) {
  updateDocuments(treatmentId: $treatmentId, content: $content) {
    ...DocumentFragment
  }
}
    ${DocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const RemoveDocumentsDocument = `
    mutation removeDocuments($treatmentId: ID!, $documentIds: [ID!]!) {
  removeDocuments(treatmentId: $treatmentId, documentIds: $documentIds) {
    ...DocumentFragment
  }
}
    ${DocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const SendConsentPacketDocument = `
    mutation sendConsentPacket($treatmentId: ID!) {
  sendConsentPacket(
    content: {treatmentId: $treatmentId, forceNew: false, usingServiceUser: true, checkIfAlreadySigned: false}
  ) {
    success
    code
    message
  }
}
    `
export const UpdatePatientIntegrationDocument = `
    mutation updatePatientIntegration($treatmentId: ID!, $content: PatientIntegrationInput!) {
  updatePatientIntegration(treatmentId: $treatmentId, content: $content) {
    ...PatientIntegrationFragment
  }
}
    ${PatientIntegrationFragment}`
export const SendEligibilityVerificationDocument = `
    mutation sendEligibilityVerification($input: SendEligibilityVerificationInput!) {
  sendEligibilityVerification(input: $input) {
    ...ActionEntryFragment
  }
}
    ${ActionEntryFragment}
${AuditEntryFragment}`
export const UpdatePatientDocument = `
    mutation updatePatient($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    ...PatientResponseFragment
  }
}
    ${PatientResponseFragment}`
export const CreatePatientDocument = `
    mutation createPatient($input: CreatePatientInput!) {
  createPatient(input: $input) {
    ...PatientResponseFragment
  }
}
    ${PatientResponseFragment}`
export const RestorePatientDocument = `
    mutation restorePatient($input: RestorePatientInput!) {
  restorePatient(input: $input) {
    ...PatientResponseFragment
  }
}
    ${PatientResponseFragment}`
export const LoadPatientBillingDocument = `
    query loadPatientBilling($input: LoadPatientBillingInput!) {
  loadPatientBilling(input: $input) {
    ...BillingFullFragment
  }
}
    ${BillingFullFragment}
${FileFragment}
${ConsentPacketInfoFragment}
${AuditEntryFragment}
${BillingInsuredFragment}`
export const LoadEligibilityVerificationDocument = `
    query loadEligibilityVerification($input: LoadEligibilityVerificationInput!) {
  loadEligibilityVerification(input: $input) {
    ...CheckEligibilityFragment
  }
}
    ${CheckEligibilityFragment}
${ActionEntryFragment}
${AuditEntryFragment}`
export const GetDocumentDocument = `
    query getDocument($treatmentId: ID!, $documentId: ID!) {
  getDocument(treatmentId: $treatmentId, documentId: $documentId) {
    ...DocumentFragment
  }
}
    ${DocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetDocumentsByTreatmentIdDocument = `
    query getDocumentsByTreatmentId($treatmentId: ID!) {
  getDocumentsByTreatmentId(treatmentId: $treatmentId) {
    ...DocumentFragment
  }
}
    ${DocumentFragment}
${FileFragment}
${AuditEntryFragment}`
export const GetPatientByTreatmentIdDocument = `
    query getPatientByTreatmentId($treatmentId: ID!) {
  getPatientByTreatmentId(treatmentId: $treatmentId) {
    ...PatientFragment
  }
}
    ${PatientFragment}
${PatientIntegrationFragment}
${PatientDemographicsFragment}
${ContactFragment}
${PatientCareFragment}
${CareTeamMemberFragment}`
export const ListEligibilityVerificationsDocument = `
    query listEligibilityVerifications($input: ListEligibilityVerificationInput!) {
  listEligibilityVerifications(input: $input) {
    ...CheckEligibilityFragment
  }
}
    ${CheckEligibilityFragment}
${ActionEntryFragment}
${AuditEntryFragment}`
export const ListPatientEligibilityVerificationsDocument = `
    query listPatientEligibilityVerifications($input: ListPatientEligibilityVerificationInput!) {
  listPatientEligibilityVerifications(input: $input) {
    ...CheckEligibilityFragment
  }
}
    ${CheckEligibilityFragment}
${ActionEntryFragment}
${AuditEntryFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    savePatientBilling: build.mutation<
      Types.SavePatientBilling,
      Types.SavePatientBillingVariables
    >({
      query: (variables) => ({
        document: SavePatientBillingDocument,
        variables,
      }),
    }),
    generatePatientLink: build.mutation<
      Types.GeneratePatientLink,
      Types.GeneratePatientLinkVariables
    >({
      query: (variables) => ({
        document: GeneratePatientLinkDocument,
        variables,
      }),
    }),
    appendDocuments: build.mutation<
      Types.AppendDocuments,
      Types.AppendDocumentsVariables
    >({
      query: (variables) => ({ document: AppendDocumentsDocument, variables }),
    }),
    updateDocuments: build.mutation<
      Types.UpdateDocuments,
      Types.UpdateDocumentsVariables
    >({
      query: (variables) => ({ document: UpdateDocumentsDocument, variables }),
    }),
    removeDocuments: build.mutation<
      Types.RemoveDocuments,
      Types.RemoveDocumentsVariables
    >({
      query: (variables) => ({ document: RemoveDocumentsDocument, variables }),
    }),
    sendConsentPacket: build.mutation<
      Types.SendConsentPacket,
      Types.SendConsentPacketVariables
    >({
      query: (variables) => ({
        document: SendConsentPacketDocument,
        variables,
      }),
    }),
    updatePatientIntegration: build.mutation<
      Types.UpdatePatientIntegration,
      Types.UpdatePatientIntegrationVariables
    >({
      query: (variables) => ({
        document: UpdatePatientIntegrationDocument,
        variables,
      }),
    }),
    sendEligibilityVerification: build.mutation<
      Types.SendEligibilityVerification,
      Types.SendEligibilityVerificationVariables
    >({
      query: (variables) => ({
        document: SendEligibilityVerificationDocument,
        variables,
      }),
    }),
    updatePatient: build.mutation<
      Types.UpdatePatient,
      Types.UpdatePatientVariables
    >({
      query: (variables) => ({ document: UpdatePatientDocument, variables }),
    }),
    createPatient: build.mutation<
      Types.CreatePatient,
      Types.CreatePatientVariables
    >({
      query: (variables) => ({ document: CreatePatientDocument, variables }),
    }),
    restorePatient: build.mutation<
      Types.RestorePatient,
      Types.RestorePatientVariables
    >({
      query: (variables) => ({ document: RestorePatientDocument, variables }),
    }),
    loadPatientBilling: build.query<
      Types.LoadPatientBilling,
      Types.LoadPatientBillingVariables
    >({
      query: (variables) => ({
        document: LoadPatientBillingDocument,
        variables,
      }),
    }),
    loadEligibilityVerification: build.query<
      Types.LoadEligibilityVerification,
      Types.LoadEligibilityVerificationVariables
    >({
      query: (variables) => ({
        document: LoadEligibilityVerificationDocument,
        variables,
      }),
    }),
    getDocument: build.query<Types.GetDocument, Types.GetDocumentVariables>({
      query: (variables) => ({ document: GetDocumentDocument, variables }),
    }),
    getDocumentsByTreatmentId: build.query<
      Types.GetDocumentsByTreatmentId,
      Types.GetDocumentsByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: GetDocumentsByTreatmentIdDocument,
        variables,
      }),
    }),
    getPatientByTreatmentId: build.query<
      Types.GetPatientByTreatmentId,
      Types.GetPatientByTreatmentIdVariables
    >({
      query: (variables) => ({
        document: GetPatientByTreatmentIdDocument,
        variables,
      }),
    }),
    listEligibilityVerifications: build.query<
      Types.ListEligibilityVerifications,
      Types.ListEligibilityVerificationsVariables
    >({
      query: (variables) => ({
        document: ListEligibilityVerificationsDocument,
        variables,
      }),
    }),
    listPatientEligibilityVerifications: build.query<
      Types.ListPatientEligibilityVerifications,
      Types.ListPatientEligibilityVerificationsVariables
    >({
      query: (variables) => ({
        document: ListPatientEligibilityVerificationsDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
